export default __webpack_public_path__ + "static/media/500.7ef15751.png";